import { useEffect, useState } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { API_URL } from "../config";
import { flattenHierarchy } from "../utils/hierarchyUtils";
import { mapEmployee } from "../utils/employeeMapper";

// Employees list + hierarchy expand/collapse state
export const useEmployees = ({ profile, language, text, setLoading, setError }) => {
  // Employee data state
  const [employees, setEmployees] = useState([]);

  const [expandedEmployees, setExpandedEmployees] = useState(() => {
    const myCode = localStorage.getItem("infinityCode");
    return myCode ? new Set([myCode]) : new Set();
  });

  // Toggle expand/collapse for a hierarchy node
  const toggleEmployeeExpand = (infinityCode) => {
    setExpandedEmployees(prev => {
      const newSet = new Set(prev);
      if (newSet.has(infinityCode)) {
        newSet.delete(infinityCode);
      } else {
        newSet.add(infinityCode);
      }
      return newSet;
    });
  };

  const fetchEmployees = async () => {
    try {
      setLoading(true);

      const clientName = profile?.clientName || localStorage.getItem("clientName");
      const myInfinityCode = profile?.infinityCode || localStorage.getItem("infinityCode");

      let response;

      if (clientName && clientName.toLowerCase() !== "infinity") {
        console.log(`📡 Fetching hierarchy for client: ${clientName}, manager: ${myInfinityCode}`);

        response = await apiFetch(
          `${API_URL}/employees/clients/${clientName}/hierarchy?managerInfinityCode=${myInfinityCode}`,
          { method: "GET" }
        );
      } else {
        console.log("📡 Fetching all employees");
        response = await apiFetch(`${API_URL}/employees`, { method: "GET" });
      }

      let employeesData;

      // Check if response contains hierarchy structure
      const json = await response.json();
      if (json.hierarchy) {
        // Flatten the hierarchy for table display
        employeesData = flattenHierarchy(json.hierarchy[0], expandedEmployees);
      } else {
        employeesData = json.employees || json;
      }

      console.log(`✅ Received ${employeesData.length} employees`);

      // Map employees with ALL fields
      const mappedEmployees = employeesData.map((emp) => mapEmployee(emp, language, text));

      setEmployees(mappedEmployees);
      console.log(`✅ Successfully mapped ${mappedEmployees.length} employees`);
    } catch (err) {
      console.error("❌ Failed to fetch employees:", err);
      setError("Failed to fetch employees data");
    } finally {
      setLoading(false);
    }
  };

  // Re-fetch when expandedEmployees changes
  useEffect(() => {
    if (employees.length > 0) {
      fetchEmployees();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedEmployees]);

  return { employees, setEmployees, expandedEmployees, toggleEmployeeExpand, fetchEmployees };
};
